import React from "react";

// components
import IconButton from "@mui/material/IconButton";
import CopyIcon from "@mui/icons-material/FileCopy";
import { Links, Header, CopyDiv, Text } from "./ChannelDetailDisplayDiv";
import { Button, Dialog, DialogActions, DialogContent, Tab, Tabs, Box } from "@mui/material";

const rtmpLinks = [
  {
    name: "RTMP In",
    selector: "rtmp_in",
    copy: true
  },
  {
    name: "Stream Key",
    selector: "key",
    copy: true
  },
  {
    name: "RTMP Out",
    selector: "rtmp_out",
    copy: true
  },
]

const srtLinks = [
  {
    name: "SRT In",
    selector: "srt_in",
    copy: true
  },
  {
    name: "SRT Out",
    selector: "srt_out",
    copy: true
  },
]

const hlsLinks = [
  {
    name: "HLS Link 1 (Recommended)",
    selector: "hls",
    copy: true
  },
  {
    name: "HLS Link 2",
    selector: "redirect_url",
    copy: true
  },
  {
    name: "Preview",
    selector: "preview_url",
    copy: true
  },
]


const ChannelLinks = ({ channel, links }) => {
  
  const _onCopy = (text) => {
    navigator.clipboard.writeText(text).then(function () {
    });
  };

  const _getChanneKey = (channelName="NA") => {
    return `${channelName}?token=${channelName}`
  } 

  return (
    <Links>
      {links.map((l) => {
        const text = channel?.[l.selector];
        return (
          <CopyDiv key={l.name}>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }} >
              <Header>{l.name}</Header>
              {
                l.selector === "key" ? <Text>{_getChanneKey(channel?.name)}</Text> : <Text>{text || "-"}</Text>
              }
            </div>
            {
              l["copy"] && (
                <IconButton onClick={() => _onCopy(text)}>
                  <CopyIcon fontSize="small" />
                </IconButton>
              )
            }
          </CopyDiv>
        );
      })}
    </Links>
  );
};

const ChannelLinkModal = ({ open, onClose, channel }) => {
  const [activeTab, setActiveTab] = React.useState(0);
  const [activeLinks, setActiveLinks] = React.useState(rtmpLinks);

  const handleTabChange = (_, newValue) => {
    setActiveTab(newValue);
    switch(+newValue){
      case 0:
        setActiveLinks(rtmpLinks);
        break;
      case 1:
        setActiveLinks(srtLinks);
        break;
      case 2:
        setActiveLinks(hlsLinks);
        break;
      default:
        setActiveLinks(rtmpLinks);
        break;
    }
  };

  return (
    <Dialog
      open={open}
      keepMounted
      onClose={onClose}
      aria-labelledby="delete-channel-confirmation"
      maxWidth={"sm"}
      fullWidth
    >
      <DialogContent sx={{ textAlign: "center" }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 4 }}>
          <Tabs
            value={activeTab}
            onChange={handleTabChange}
            variant="fullWidth"
            aria-label="streaming protocol tabs"
          >
            <Tab label="RTMP" />
            <Tab label="SRT" />
            <Tab label="HLS" />
          </Tabs>
        </Box>
        <ChannelLinks channel={channel} links={activeLinks} />
      </DialogContent>
      <DialogActions >
        <Button
          onClick={onClose}
          variant="outlined"
          color="primary"
          disableElevation
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ChannelLinkModal;
